import { render, staticRenderFns } from "./SopTemplatesWidget.vue?vue&type=template&id=6e91c484&"
import script from "./SopTemplatesWidget.vue?vue&type=script&lang=ts&"
export * from "./SopTemplatesWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports